
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface InvestmentFilterProps {
  value: string;
  onChange: (value: string) => void;
}

const InvestmentFilter = ({ value, onChange }: InvestmentFilterProps) => {
  return (
    <div className="space-y-2">
      <Label className="text-sm font-bold text-[#1B2F47]">
        Minimum Investment
      </Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger 
          id="investment" 
          className="w-full bg-white border-[#D3DCE4] h-10 text-sm rounded-md"
        >
          <SelectValue placeholder="Select amount" />
        </SelectTrigger>
        <SelectContent className="bg-white">
          <SelectItem value="all">All Amounts</SelectItem>
          <SelectItem value="500">500 USDT or less</SelectItem>
          <SelectItem value="1000">1,000 USDT or less</SelectItem>
          <SelectItem value="2500">2,500 USDT or less</SelectItem>
          <SelectItem value="2501">2,501 USDT or more</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default InvestmentFilter;
